export enum ListColumnType {
  Weight = 1,
  UserName = 2,
  IntakeSurveys = 3,
  Symptoms = 4,
  ProgramStatus = 5
}
